import React, { useState } from 'react';
import LogInSignUpTemplate from '../components/template/LogInSignUpTemplate';
import loginImage from '../assets/Images/login.webp';
import ConfirmationModal from '../components/common/ConfirmationModal';

const LogIn = () => {
    const [confirmationModal, setConfirmationModal] = useState(null);
    return (
        <div className='md:mt-32 mt-14'>
            <LogInSignUpTemplate
                heading={'Welcome Back'}
                desc1={'Build skills for today, tomorrow, and beyond.'}
                desc2={'Education to future-proof your career.'}
                formType={'login'}
                image={loginImage}
                setLoginConfirmationModal={setConfirmationModal}
            />
            {confirmationModal && <ConfirmationModal modalData={confirmationModal} />}
        </div>
    );
}

export default LogIn;